export default __webpack_public_path__ + "static/media/no-jobs.98d2b69c.png";